import UserPropertiesHowToSet from "../../../../contents/docs/getting-started/_snippets/user-properties-how-to-set.mdx";
import UserPropertiesSetVsSetOnce from "../../../../contents/docs/getting-started/_snippets/user-properties-set-vs-set-once.mdx";
import * as React from 'react';
export default {
  UserPropertiesHowToSet,
  UserPropertiesSetVsSetOnce,
  React
};